let cid = 1;
function buildParams(params) {
  const result = [];
  for (const key in params) {
    result.push(`${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`);
  }
  return result.join('&');
}
/**
 *
 * JSONP -AJAX
 * @param {*} config
 * @param {boolean} [timestamp=false] 是否增加时间戳
 * @returns
 */
function axiosJsonp(config, timestamp = false) {
  return new Promise((resolve, reject) => {
    let script = document.createElement('script');
    let src = config.url;
    const additionalParams = {};
    // 判断 增加时间戳
    if (timestamp) additionalParams.timestamp = (new Date().getTime());
    cid += 1;
    const jsonp = `axiosJsonpCallback${cid}`;
    const old = window[jsonp];
    let isAbort = false;
    if (config.params) {
      const params = buildParams(config.params);

      if (params) {
        src += (src.indexOf('?') >= 0 ? '&' : '?') + params;
      }
    }

    script.async = true;
    window[jsonp] = (responseData) => {
      window[jsonp] = old;

      if (isAbort) {
        return;
      }
      const response = {
        data: responseData,
        status: 200,
      };

      resolve(response);
    };


    additionalParams[config.callbackParamName || 'callback'] = jsonp;
    additionalParams[config.callbackParamName || '_callback'] = jsonp;
    src += (src.indexOf('?') >= 0 ? '&' : '?') + buildParams(additionalParams);

    script.onload = script.onreadystatechange = () => {
      if (!script.readyState || /loaded|complete/.test(script.readyState)) {

        script.onload = script.onreadystatechange = null;

        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }

        script = null;
      }
    };

    if (config.cancelToken) {
      config.cancelToken.promise.then((cancel) => {
        if (!script) {
          return;
        }
        isAbort = true;
        reject(cancel);
      });
    }

    script.src = src;

    window.document.head.appendChild(script);
  });
}
export { axiosJsonp };



// WEBPACK FOOTER //
// ./src/util/jsonp.js